"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHexColor = exports.validateColor = void 0;

var validateColor = function validateColor(color) {
  var isHex = isHexColor(color);
  var e = document.getElementById('divValidColor');

  if (!e) {
    e = document.createElement('div');
    e.id = 'divValidColor';
  }

  e.style.borderColor = '';
  e.style.borderColor = color;
  var tmpcolor = e.style.borderColor;
  return tmpcolor.length !== 0 && isHex;
};

exports.validateColor = validateColor;

var isHexColor = function isHexColor(color) {
  return color.match(/^#[a-f0-9]{6}$/i) !== null || color.match(/^#[a-f0-9]{3}$/i) !== null;
};

exports.isHexColor = isHexColor;